import { Box, Typography } from '@mui/material';

interface FeaturesSectionProps {
    features: string[];
}

export const FeaturesSection = ({ features }: FeaturesSectionProps) => {
    if (!features || features.length === 0) return null;

    return (
        <Box sx={{ marginBottom: 3 }}>
            <Typography sx={{ 
                fontSize: '0.7rem',
                fontWeight: 700,
                color: '#64748b',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                marginBottom: 2
            }}>
                ✨ Features
            </Typography>
            <Box sx={{ 
                padding: 2.5,
                background: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: 2
            }}>
                {features.map((feature, index) => (
                    <Box 
                        key={index}
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 1.5,
                            marginBottom: index < features.length - 1 ? 1.5 : 0,
                            paddingBottom: index < features.length - 1 ? 1.5 : 0,
                            borderBottom: index < features.length - 1 ? '1px solid #f1f5f9' : 'none'
                        }}
                    >
                        <Typography sx={{ 
                            fontSize: '0.9rem',
                            color: '#10b981',
                            fontWeight: 700,
                            minWidth: '20px'
                        }}>
                            ✓
                        </Typography>
                        <Typography sx={{ 
                            fontSize: '0.9rem',
                            color: '#334155',
                            lineHeight: 1.6,
                            flex: 1
                        }}>
                            {feature}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
